export default __webpack_public_path__ + "static/media/qrcode_logo.03f708cd.svg";